/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import SubTitleContents from "reusables/TextFormats/SubTitleContents";
import ExtraServices from "reusables/sections/ExtraServices";

function Office_Section5() {
  return (
    <Container>
      <ExtraServices
        description="While our regular cleaning services are thorough, there are some specialized tasks that fall outside the scope. These can be requested as add-ons for an additional fee:"
        services={[
          "Carpet Shampooing or Deep Carpet Cleaning",
          "Deep Cleaning of Kitchen Appliances (e.g., inside ovens, microwaves, or refrigerators)",
          "Window Cleaning (Exterior or High Windows)",
          "Decluttering or Organizing Personal or Office Items",
          "Wall or Ceiling Cleaning",
          "Removing Heavy Stains or Mold",
          "IT Equipment Cleaning Beyond Surface Wiping",
          "Furniture Upholstery Cleaning",
        ]}
      />
    </Container>
  );
}

export default Office_Section5;

// /* eslint-disable prettier/prettier */
// /* eslint-disable no-unused-vars */
// import Container from "@mui/material/Container";
// import Grid from "@mui/material/Grid";
// import Icon from "@mui/material/Icon";
// import Divider from "@mui/material/Divider";

// // Material Kit 2 React components
// import MKBox from "components/MKBox";
// import MKTypography from "components/MKTypography";

// import SubTitleContents from "reusables/TextFormats/SubTitleContents";

// function Office_Section5() {
//   return (
//     <Container>
//       <Grid
//         container
//         item
//         display={"flex"}
//         flexDirection={"column"}
//         alignItems="center"
//         width={"100%"}
//         // mx={0}
//         // px={0}
//       >
//         <Grid item>
//           <SubTitleContents
//             title="What’s NOT Included in Our Regular Office Cleaning Services?"
//             contents="While we cover a comprehensive range of cleaning tasks, some specialized or deep-cleaning services are not included in regular office cleaning. These can be requested separately for an additional fee:"
//           />
//         </Grid>
//         <Divider sx={{ width: "100%", my: 2, borderWidth: 2 }} />
//         <Grid
//           item
//           display={"flex"}
//           flexDirection={"column"}
//           justifyContent="space-between"
//           width={"100%"}
//           mb={2}
//         >
//           <Grid item xs={12} md={4} display={"flex"} flexDirection={"row"} pr={3}>
//             <MKBox
//               // bgColor="primary"
//               // color="primary"
//               display="flex"
//               //   alignItems="center"
//               mr={1}
//             >
//               <Icon fontSize="small" sx={{ fontWeight: "bold" }}>
//                 add
//               </Icon>
//             </MKBox>
//             <MKBox display="flex">
//               <MKTypography
//                 variant="body2"
//                 color="text"
//                 sx={{ textAlign: "justify", wordbreak: "break-all" }}
//               >
//                 Carpet Shampooing or Deep Carpet Cleaning
//               </MKTypography>
//             </MKBox>
//           </Grid>

//           <Grid item xs={12} md={4} display={"flex"} flexDirection={"row"} pr={3}>
//             <MKBox
//               // bgColor="primary"
//               // color="primary"
//               display="flex"
//               //   alignItems="center"
//               mr={1}
//             >
//               <Icon fontSize="small" sx={{ fontWeight: "bold" }}>
//                 add
//               </Icon>
//             </MKBox>
//             <MKBox display="flex">
//               <MKTypography
//                 variant="body2"
//                 color="text"
//                 sx={{ textAlign: "justify", wordbreak: "break-all" }}
//               >
//                 Deep Cleaning of Kitchen Appliances
//                 <br />
//                 (e.g., inside ovens, microwaves, or refrigerators)
//               </MKTypography>
//             </MKBox>
//           </Grid>

//           <Grid item xs={12} md={4} display={"flex"} flexDirection={"row"} pr={3}>
//             <MKBox
//               // bgColor="primary"
//               // color="primary"
//               display="flex"
//               //   alignItems="center"
//               mr={1}
//             >
//               <Icon fontSize="small" sx={{ fontWeight: "bold" }}>
//                 add
//               </Icon>
//             </MKBox>
//             <MKBox display="flex">
//               <MKTypography
//                 variant="body2"
//                 color="text"
//                 sx={{ textAlign: "justify", wordbreak: "break-all" }}
//               >
//                 Window Cleaning
//                 <br />
//                 (Exterior or High Windows)
//               </MKTypography>
//             </MKBox>
//           </Grid>
//         </Grid>
//         <Grid
//           item
//           display={"flex"}
//           flexDirection={"row"}
//           justifyContent="space-between"
//           width={"100%"}
//           mb={2}
//         >
//           <Grid item xs={12} md={4} display={"flex"} flexDirection={"row"} pr={3}>
//             <MKBox
//               // bgColor="primary"
//               // color="primary"
//               display="flex"
//               //   alignItems="center"
//               mr={1}
//             >
//               <Icon fontSize="small" sx={{ fontWeight: "bold" }}>
//                 add
//               </Icon>
//             </MKBox>
//             <MKBox display="flex">
//               <MKTypography
//                 variant="body2"
//                 color="text"
//                 sx={{ textAlign: "justify", wordbreak: "break-all" }}
//               >
//                 Decluttering or Organizing Personal or Office Items    dfsdfewfdsfdsfwefdsfdsfefdsfewf
//               </MKTypography>
//             </MKBox>
//           </Grid>

//           <Grid item xs={12} md={4} display={"flex"} flexDirection={"row"} pr={3}>
//             <MKBox
//               // bgColor="primary"
//               // color="primary"
//               display="flex"
//               //   alignItems="center"
//               mr={1}
//             >
//               <Icon fontSize="small" sx={{ fontWeight: "bold" }}>
//                 add
//               </Icon>
//             </MKBox>
//             <MKBox display="flex">
//               <MKTypography
//                 variant="body2"
//                 color="text"
//                 sx={{ textAlign: "justify", wordbreak: "break-all" }}
//               >
//                 Wall or Ceiling Cleaning
//               </MKTypography>
//             </MKBox>
//           </Grid>

//           <Grid item xs={12} md={4} display={"flex"} flexDirection={"row"} pr={3}>
//             <MKBox
//               // bgColor="primary"
//               // color="primary"
//               display="flex"
//               //   alignItems="center"
//               mr={1}
//             >
//               <Icon fontSize="small" sx={{ fontWeight: "bold" }}>
//                 add
//               </Icon>
//             </MKBox>
//             <MKBox display="flex">
//               <MKTypography
//                 variant="body2"
//                 color="text"
//                 sx={{ textAlign: "justify", wordbreak: "break-all" }}
//               >
//                 Removing Heavy Stains or Mold dfdsfwedsfds dfewfdsfewfdsfewsfdsfesdfdsfesdsdf
//                 dfwefdsfaidfjewifjidsjfiwejifjdsifjsid fjiewsj fidsjfi jweifjidsjfisdjfiwejifdjsifjisdjiewsjfidsjfisjdi
//               </MKTypography>
//             </MKBox>
//           </Grid>
//         </Grid>
//         <Grid
//           item
//           display={"flex"}
//           flexDirection={"row"}
//           justifyContent="space-between"
//           width={"100%"}
//           mb={2}
//         >
//           <Grid item xs={12} md={4} display={"flex"} flexDirection={"row"} pr={3} bgcolor={"pink"}>
//             <MKBox
//               // bgColor="primary"
//               // color="primary"
//               display="flex"
//               //   alignItems="center"
//               mr={1}
//             >
//               <Icon fontSize="small" sx={{ fontWeight: "bold" }}>
//                 add
//               </Icon>
//             </MKBox>
//             <MKBox display="flex">
//               <MKTypography
//                 variant="body2"
//                 color="text"
//                 sx={{ textAlign: "justify", wordbreak: "break-all" }}
//               >
//                 IT Equipment Cleaning Beyond Surface Wiping
//               </MKTypography>
//             </MKBox>
//           </Grid>
//           <Grid item xs={12} md={4} display={"flex"} flexDirection={"row"} pr={3} bgcolor={"lightblue"}>
//             <MKBox
//               // bgColor="primary"
//               // color="primary"
//               display="flex"
//               //   alignItems="center"
//               mr={1}
//             >
//               <Icon fontSize="small" sx={{ fontWeight: "bold" }}>
//                 add
//               </Icon>
//             </MKBox>
//             <MKBox display="flex">
//               <MKTypography
//                 variant="body2"
//                 color="text"
//                 sx={{ textAlign: "justify", wordbreak: "break-all" }}
//               >
//                 Furniture Upholstery Cleaning
//               </MKTypography>
//             </MKBox>
//           </Grid>
//           <Grid item xs={12} md={4} display={"flex"} flexDirection={"row"} pr={3} bgcolor={"yellow"}>
//           </Grid>
//         </Grid>
//         <Divider sx={{ width: "100%", my: 2, borderWidth: 2 }} />
//         <Grid
//           item
//           xs={12}
//           width="100%"
//           // bgcolor={"pink"}
//           display={"flex"}
//           flexDirection={"row"}
//           alignItems={"center"}
//         >
//           <MKBox display="flex" pr={2}>
//             <Icon fontSize="large" color="info">
//               info
//             </Icon>
//           </MKBox>
//           <MKBox display="flex" textAlign="left">
//             <MKTypography variant="body3" color="info">
//               If your office requires additional services, we’re happy to provide them! These
//               add-ons can be arranged at your request based on your specific needs.
//             </MKTypography>
//           </MKBox>
//         </Grid>
//       </Grid>
//     </Container>
//   );
// }

// export default Office_Section5;
